import { useContext } from 'react';

import { UserEarnActionListResponseDataItem } from '@utx/utx-client';
import { LayoutContext } from 'contexts/LayoutContext';
import { PaginationParams } from '@/design-system/components/pagination/Pagination';
import { ActivityHistoryFilterParams } from '../../components/activityHistory/ActivityHistoryFilter';
import { useSubscription } from '../portfolio/hooks/useSubscription.hook';
import { ActivityHistoryNative } from './ActivityHistoryNative';
import { ActivityHistoryWeb } from './ActivityHistoryWeb';
import { t } from 'i18next';
import { EarnContext } from '../../contexts/useEarnContext';
export interface ActivityHistoryProps {
  loading: boolean;
  filter: ActivityHistoryFilterParams;
  categoriesFilters: Array<{ label: string; value: string }>;
  subscriptions: Array<UserEarnActionListResponseDataItem>;
  paginationParams: PaginationParams;
  onFilterChange: (values: ActivityHistoryFilterParams) => void;
}

export const ActivityHistory: React.FC<{}> = ({}) => {
  const layout = useContext(LayoutContext);
  const earnContext = useContext(EarnContext);

  const subscription = useSubscription({ paginatedProps: {} });

  const defaultFilter = [
    {
      label: t('earn-invest::glossary.all-categories'),
      value: ''
    }
  ];
  const newCategories = defaultFilter.concat(earnContext.offerCategories.map((category) => ({ label: category, value: category })));
  const uniqueCategories = newCategories.filter((item, index) => {
    return newCategories.findIndex((item2) => item2.value === item.value) === index;
  });

  const activityHistoryProps: ActivityHistoryProps = {
    filter: subscription.filter,
    loading: subscription.query.isFetching,
    subscriptions: subscription.displayData,
    categoriesFilters: uniqueCategories,
    paginationParams: {
      currentPage: subscription.current,
      totalPages: subscription.totalPages,
      onNextPage: subscription.onNext,
      onPrevPage: subscription.onPrev
    },
    onFilterChange: subscription.onChangeFilter
  };

  if (layout.isMobile) {
    return <ActivityHistoryNative {...activityHistoryProps} />;
  }

  return <ActivityHistoryWeb {...activityHistoryProps} />;
};
